const MOMENTJS_DATE_FORMATES = {
  toAmPm: 'DD/MM/YYYY hh:mm a',
  toDateTimeWithss: 'YYYY-MM-DD HH:mm:ss',
  toDate: 'YYYY-MM-DD',
  toTime: 'HH:mm',
  toTimeSec: 'HH:mm:ss',
  toDateFE: 'DD/MM/YYYY',
  toDateText: 'DD MMM YYYY',
  toDayAndDate: 'dddd, DD MMMM YYYY',
  toYear: 'YYYY',
  toYearMonth: 'YYYY-MM',
  toZ: 'YYYY-MM-DDTHH:mm:ss.SSSSSS[Z]',
  toDateTimeWithoutss: 'YYYY-MM-DD HH:mm',
  cardDate: 'MMMM D, YYYY - dddd',
  ampmtime: "hh:mm A"
};

export default MOMENTJS_DATE_FORMATES;
